import React, { Component } from "react"
import { Row, Col } from "antd"
import { observer, inject } from "mobx-react"
import overviewIcon from "app/styles/images/sp/overview-selected.svg"
import BarEcharts from 'app/components/normal/BarEcharts'

const TYPE = [{
  name: "data",
  title: "数据",
  unit: "条",
  color: ["#87c5ff", "rgba(135, 197, 255, 0.2)"]
}, {
  name: "size",
  title: "存储",
  unit: "GB",
  color: ["#ace1b7", "rgba(172, 225, 183, 0.2)"]
}, {
  name: "report",
  title: "报告",
  unit: "份",
  color: ["#ffcd66", "rgba(255, 205, 102, 0.2)"]
}, {
  name: "flow",
  title: "下载",
  unit: "GB",
  color: ["#EC7063", "rgba(236, 112, 99, 0.2)"]
}]

@inject("store") @observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getChartData()
  }
  render() {
    const { store: { chartData } } = this.props
    return (
      <div>
        <h2 className="page-title">
          <img alt="" src={overviewIcon} />数据总览
        </h2>
        <Row className="dashboard-chart-list">
          {TYPE.map((item, index) => {
            return (
              <Col span={12} key={index}>
                <BarEcharts
                  mold='group'
                  data={chartData[item.name]}
                  type={item}
                />
              </Col>
            )
          })}
        </Row>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/dashboard/containers/DataChart.js